<template>
    <component :is="card ? 'BaseCard' : 'div'">
        <div :class="{ columns: row }">
            <div v-for="index in chartCount" :key="index" :class="row ? 'column' : 'chart-wrap'">
                <div class="chart loader" :style="{ height: chartHeight + 'px' }" />
            </div>
        </div>
        <div v-if="table" class="table-placeholder">
            <div class="table-head loader" />
            <LaTableLoader />
        </div>
    </component>
</template>

<script>
import BaseCard from "@/components/BaseCard";
import LaTableLoader from "@/components/loaders/TableLoader";

export default {
    name: "LaDataCardLoader",
    components: {
        BaseCard,
        LaTableLoader,
    },
    props: {
        // Number of chart placeholders; mirrors how many charts the card renders once loaded.
        chartCount: {
            type: Number,
            required: false,
            default: 1,
        },
        // Height of a single chart in px — the charts use inline `style="height: ...px"`,
        // so the placeholder has to be given the same number to avoid a layout jump.
        chartHeight: {
            type: Number,
            required: false,
            default: 350,
        },
        table: {
            type: Boolean,
            required: false,
            default: true,
        },
        // Charts side by side instead of stacked (BlockRateDataCard renders them in one row).
        row: {
            type: Boolean,
            required: false,
            default: false,
        },
        // Wrap in a BaseCard — for the spots where the loader stands in for the whole card,
        // not just its content.
        card: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.chart {
    background: $grey;
    border-radius: $normal-radius;
}

.chart-wrap {
    margin-bottom: 2rem;

    &:last-child {
        margin-bottom: 0;
    }
}

// Matches the `margin-top: 2rem` wrapper the real table sits in.
.table-placeholder {
    margin-top: 2rem;
}

// Matches .table-header in BaseTable (padding: 1rem 0 around 0.8rem text).
.table-head {
    height: 3rem;
    background: $grey;
    border-radius: 4px;
    margin-bottom: 0.5rem;
}
</style>
